









import { Component, Vue } from 'vue-property-decorator';

import { ConfigsModuleMapper } from '@/store/modules/config';
import FooterPhone from './footerPhone.vue';
import FooterSocial from './footerSocial.vue';
import FooterCopyright from './footerCopyright.vue';

const Mappers = Vue.extend({
  computed: {
    ...ConfigsModuleMapper.mapGetters(['configIsLoaded', 'contactsEnabled']),
  },
});

@Component({
  components: {
    FooterPhone,
    FooterSocial,
    FooterCopyright,
  },
})
export default class FooterComponent extends Mappers {
}
